<section>
  <div class="uk-overflow-auto" style="transform: none; width: 98%; padding-left: 1%; max-height: 90vh">
    <app-tabs [type]="'underlined'"
              [tabNamesRaw]="['Forms','Graphics','Charts','Input', 'Selectors', 'Inputs', 'Icons' , 'Buttons', 'Notifications', 'Test', 'Modal', 'LinkedIn', 'drop-down', 'skeleton', 'tooltips']"
              (selectedTabEmitter)="selectedTab=$event">
    </app-tabs>
    <div class="black-line for-padding-1p25"></div> <!--U can use this line e.g. for modal-->
    <div class="whitespace-1"></div>
    <div
      [ngSwitch]="selectedTab">
      <div *ngSwitchCase="'Forms'">
        <form [formGroup]="form"
              (ngSubmit)="submit()">
            <span class="bold500">More complex example is presented in FundStrategyTableComponent. </span>
            <span>Here is just syntax example</span>
            <div formArrayName="firstArray">
              <span>First level array</span>
              <div *ngFor="let dataFromArray of [1]; let j = index;" [formGroupName]="j">
                <app-input formControlName = "name"></app-input>
                <div formArrayName="secondArray">
                  <span>Second level array</span>
                  <div *ngFor="let dataFromArray of [1]; let j2 = index;" [formGroupName]="j2">
                    <app-input formControlName="name"></app-input>
                    <div formArrayName="thirdArray">
                      <span>Third level array</span>
                      <div *ngFor="let dataFromArray of [1]; let j3 = index;" [formGroupName]="j3">
                        <app-input formControlName = "roundNumber"></app-input>
                        <app-input formControlName = "companies"></app-input>
                    </div>
                  </div>
                </div>
                </div>
              </div>
              </div>
          <button type="submit">Submit form</button>
          <h1>{{submitFormValue}}</h1>
        </form>
      </div>

      <div class="mb-1" *ngSwitchCase="'Graphics'">
        <app-vertical-charts [data]="graphicData" [yLevels]="5"></app-vertical-charts>
      </div>
      <ng-container *ngSwitchCase="'Input'">
        <app-tabs [tabNamesRaw]="['Vanila', 'Auto-Input']" (selectedTabEmitter)="selectedInputTab=$event">

        </app-tabs>
        <div [ngSwitch]="selectedInputTab">
          <ng-container *ngSwitchCase="'Vanilla'">
            <div class="big-container" style="width: 75vw;">
              <div class="start-row-container row-gap-1 margin-container">
                <app-input [title]="'Input with button'" [input]="'blablablablablablablablablablablablablablablabla'"
                           [buttonProps]="{size: 'small', text: 'ABCD', type: 'grey'}">
                </app-input>
                <app-input [title]="'Input with button'"
                           [buttonProps]="{type: 'grey', showIcon: 'input-only', iconName: 'calculator.svg'}">
                </app-input>

                <app-input
                  [title]="'TEST'"
                  [suffixSecondIcon]="'search.svg; black-9'"
                  [suffixFirstIcon]="'exclamation.svg'">
                </app-input>
                <app-input [title]="'Name'"
                           [prefixFirstIcon]="'search.svg'"
                           [suffixFirstIcon]="'open-eye.svg'"
                           [suffixSecondIcon]="'password-eye-opened.svg; main-8' "
                           [firstSuffixImageTooltip]="'what a tooltip c:'"
                           [secondSuffixImageTooltip]="'huh not expected'"
                           [bottomText]="'Verkaufe Parkplatz'" [(input)]="inputValue" [placeholder]="'Type...'">
                </app-input>

                <app-input [additionalClass]="'disabled'" [placeholder]="'I am disabled pls help...'">
                </app-input>

                <app-input [title]="'Name'"
                           [prefixFirstIcon]="'search.svg'"
                           [suffixFirstIcon]="'password-eye-opened.svg'"
                           [firstSuffixImageTooltip]="'what a tooltip c:'" [bottomText]="'Verkaufe Parkplatz'"
                           [additionalClass]="'error'" [input]="'wrongValue'">
                </app-input>
                {{inputValue}}
              </div>
              <img src="../../../../assets/tutorials/Input-Tutorial.png" alt="tutorial">
            </div>

          </ng-container>
          <ng-container *ngSwitchCase="'Auto-Input'">
            <div class="big-container" style="width: 75vw;">
              <app-input-autocomplete [data]="[1,2,3,4]" [title]="'TEST'" (valueEmitter)="autoInputValue=$event">
              </app-input-autocomplete>
              {{autoInputValue}}
            </div>
          </ng-container>
        </div>
      </ng-container>

      <ng-container *ngSwitchCase="'Selectors'">
        <app-tabs [tabNamesRaw]="['Used']" (selectedTabEmitter)="selectedSelectorsTab=$event">

        </app-tabs>
        <div [ngSwitch]="selectedSelectorsTab">
          <ng-container *ngSwitchCase="'Used'">
            <div class="big-container">
              <div class="centered-row-container">

                <div class="centered-column-container select-container">

                  <div class="control" id="select-checkbox-modal" (click)="showPopUpModal=true">
                    Select options
                    <div class="suffix">
                      <img src="../../../../assets/svg/common/arrow-down.svg" alt="dropdown">
                    </div>
                  </div>

                  <app-popup-modal *ngIf="showPopUpModal" (closeModal)="showPopUpModal=false">
                    <div class="select-body">
                      <app-checkbox [(ngModel)]="checkboxValue"> First Kek</app-checkbox>
                      <app-checkbox> Second Kek</app-checkbox>
                      <app-checkbox> Third Kek</app-checkbox>
                      <app-checkbox> Fourth Kek</app-checkbox>
                    </div>
                  </app-popup-modal>
                </div>


                <app-selector [data]="complexData" (itemEmitter)="select=$event">
                </app-selector>
                {{select}}
              </div>
              {{checkboxValue}}
            </div>
          </ng-container>
        </div>
      </ng-container>
      <ng-container *ngSwitchCase="'Icons'">
        <div class="start-column-container">
          <div class="start-row-container">
            <app-all-icons class="icon-size-2" [iconNameAndStyling]="'admin-icon.svg'"></app-all-icons>
            <span class="font-3 black-9">admin-icon.svg</span>
          </div>
          <div class="start-row-container">
            <app-all-icons class="icon-size-2" [iconNameAndStyling]="'allocate.svg'"></app-all-icons>
            <span class="font-3 black-9">allocate.svg</span>
          </div>
          <div class="start-row-container">
            <app-all-icons class="icon-size-2" [iconNameAndStyling]="'arrow-down.svg'"></app-all-icons>
            <span class="font-3 black-9">arrow-down.svg</span>
          </div>
          <div class="start-row-container">
            <app-all-icons class="icon-size-2" [iconNameAndStyling]="'arrow-top-right.svg'"></app-all-icons>
            <span class="font-3 black-9">arrow-top-right.svg</span>
          </div>
          <div class="start-row-container">
            <app-all-icons class="icon-size-2" [iconNameAndStyling]="'back.svg'"></app-all-icons>
            <span class="font-3 black-9">back.svg</span>
          </div>
          <div class="start-row-container">
            <app-all-icons class="icon-size-2" [iconNameAndStyling]="'calculator.svg'"></app-all-icons>
            <span class="font-3 black-9">calculator.svg</span>
          </div>
          <div class="start-row-container">
            <app-all-icons class="icon-size-2" [iconNameAndStyling]="'chain-link.svg'"></app-all-icons>
            <span class="font-3 black-9">chain-link.svg</span>
          </div>
          <div class="start-row-container">
            <app-all-icons class="icon-size-2" [iconNameAndStyling]="'close.svg'"></app-all-icons>
            <span class="font-3 black-9">close.svg</span>
          </div>
          <div class="start-row-container">
            <app-all-icons class="icon-size-2" [iconNameAndStyling]="'copy-outline.svg'"></app-all-icons>
            <span class="font-3 black-9">copy-outline.svg</span>
          </div>
          <div class="start-row-container">
            <app-all-icons class="icon-size-2" [iconNameAndStyling]="'copy.svg'"></app-all-icons>
            <span class="font-3 black-9">copy.svg</span>
          </div>
          <div class="start-row-container">
            <app-all-icons class="icon-size-2" [iconNameAndStyling]="'crossed-eye.svg'"></app-all-icons>
            <span class="font-3 black-9">crossed-eye.svg</span>
          </div>
          <div class="start-row-container">
            <app-all-icons class="icon-size-2" [iconNameAndStyling]="'delete-outline.svg'"></app-all-icons>
            <span class="font-3 black-9">delete-outline.svg</span>
          </div>
          <div class="start-row-container">
            <app-all-icons class="icon-size-2" [iconNameAndStyling]="'reminder-active.svg'"></app-all-icons>
            <span class="font-3 black-9">delete-outline.svg</span>
          </div>
          <!-- //////////////////////////////////////////////////////////////// -->

          <div class="start-row-container">
            <app-all-icons class="icon-size-2" [iconNameAndStyling]="'delete.svg'"></app-all-icons>
            <span class="font-3 black-9">delete.svg</span>
          </div>
          <div class="start-row-container">
            <app-all-icons class="icon-size-2" [iconNameAndStyling]="'diagonal-arrow.svg'"></app-all-icons>
            <span class="font-3 black-9">diagonal-arrow.svg</span>
          </div>
          <div class="start-row-container">
            <app-all-icons class="icon-size-2" [iconNameAndStyling]="'down-arrow.svg'"></app-all-icons>
            <span class="font-3 black-9">down-arrow.svg</span>
          </div>
          <div class="start-row-container">
            <app-all-icons class="icon-size-2" [iconNameAndStyling]="'download.svg'"></app-all-icons>
            <span class="font-3 black-9">download.svg</span>
          </div>
          <div class="start-row-container">
            <app-all-icons class="icon-size-2" [iconNameAndStyling]="'edit-outline.svg'"></app-all-icons>
            <span class="font-3 black-9">edit-outline.svg</span>
          </div>
          <div class="start-row-container">
            <app-all-icons class="icon-size-2" [iconNameAndStyling]="'edit.svg'"></app-all-icons>
            <span class="font-3 black-9">edit.svg</span>
          </div>
          <div class="start-row-container">
            <app-all-icons class="icon-size-2" [iconNameAndStyling]="'empty-exclamation.svg'"></app-all-icons>
            <span class="font-3 black-9">empty-exclamation.svg</span>
          </div>
          <div class="start-row-container">
            <app-all-icons class="icon-size-2" [iconNameAndStyling]="'empty-tray.svg'"></app-all-icons>
            <span class="font-3 black-9">empty-tray.svg</span>
          </div>
          <div class="start-row-container">
            <app-all-icons class="icon-size-2" [iconNameAndStyling]="'excel.svg'"></app-all-icons>
            <span class="font-3 black-9">excel.svg</span>
          </div>
          <div class="start-row-container">
            <app-all-icons class="icon-size-2" [iconNameAndStyling]="'exclamation.svg'"></app-all-icons>
            <span class="font-3 black-9">exclamation.svg</span>
          </div>
          <div class="start-row-container">
            <app-all-icons class="icon-size-2" [iconNameAndStyling]="'exit.svg'"></app-all-icons>
            <span class="font-3 black-9">exit.svg</span>
          </div>
          <div class="start-row-container">
            <app-all-icons class="icon-size-2" [iconNameAndStyling]="'info-filled.svg'"></app-all-icons>
            <span class="font-3 black-9">info-filled.svg</span>
          </div>
          <div class="start-row-container">
            <app-all-icons class="icon-size-2" [iconNameAndStyling]="'investor-portal.svg'"></app-all-icons>
            <span class="font-3 black-9">investor-portal.svg</span>
          </div>
          <div class="start-row-container">
            <app-all-icons class="icon-size-2" [iconNameAndStyling]="'left-arrow.svg'"></app-all-icons>
            <span class="font-3 black-9">left-arrow.svg</span>
          </div>
          <div class="start-row-container">
            <app-all-icons class="icon-size-2" [iconNameAndStyling]="'lock-closed-fill.svg'"></app-all-icons>
            <span class="font-3 black-9">lock-closed-fill.svg</span>
          </div>
          <div class="start-row-container">
            <app-all-icons class="icon-size-2" [iconNameAndStyling]="'lock-opened-empty.svg'"></app-all-icons>
            <span class="font-3 black-9">lock-opened-empty.svg</span>
          </div>
          <div class="start-row-container">
            <app-all-icons class="icon-size-2" [iconNameAndStyling]="'message.svg'"></app-all-icons>
            <span class="font-3 black-9">message.svg</span>
          </div>
          <div class="start-row-container">
            <app-all-icons class="icon-size-2" [iconNameAndStyling]="'no-access-icon.svg'"></app-all-icons>
            <span class="font-3 black-9">no-access-icon.svg</span>
          </div>
          <div class="start-row-container">
            <app-all-icons class="icon-size-2" [iconNameAndStyling]="'note-add.svg'"></app-all-icons>
            <span class="font-3 black-9">note-add.svg</span>
          </div>
          <div class="start-row-container">
            <app-all-icons class="icon-size-2" [iconNameAndStyling]="'planet.svg'"></app-all-icons>
            <span class="font-3 black-9">planet.svg</span>
          </div>





          <div class="start-row-container">
            <app-all-icons class="icon-size-2" [iconNameAndStyling]="'predicted-three-bars-chart.svg'"></app-all-icons>
            <span class="font-3 black-9">predicted-three-bars-chart.svg</span>
          </div>
          <div class="start-row-container">
            <app-all-icons class="icon-size-2" [iconNameAndStyling]="'prediction.svg'"></app-all-icons>
            <span class="font-3 black-9">prediction.svg</span>
          </div>
          <div class="start-row-container">
            <app-all-icons class="icon-size-2" [iconNameAndStyling]="'right-arrow-in-circle.svg'"></app-all-icons>
            <span class="font-3 black-9">right-arrow-in-circle.svg</span>
          </div>
          <div class="start-row-container">
            <app-all-icons class="icon-size-2" [iconNameAndStyling]="'right-arrow.svg'"></app-all-icons>
            <span class="font-3 black-9">right-arrow.svg</span>
          </div>
          <div class="start-row-container">
            <app-all-icons class="icon-size-2" [iconNameAndStyling]="'sms-logo.svg'"></app-all-icons>
            <span class="font-3 black-9">sms-logo.svg</span>
          </div>
          <div class="start-row-container">
            <app-all-icons class="icon-size-2" [iconNameAndStyling]="'three-dots-menu.svg'"></app-all-icons>
            <span class="font-3 black-9">three-dots-menu.svg</span>
          </div>
          <div class="start-row-container">
            <app-all-icons class="icon-size-2" [iconNameAndStyling]="'unsell.svg'"></app-all-icons>
            <span class="font-3 black-9">unsell.svg</span>
          </div>
          <div class="start-row-container">
            <app-all-icons class="icon-size-2" [iconNameAndStyling]="'update.svg'"></app-all-icons>
            <span class="font-3 black-9">update.svg</span>
          </div>
          <div class="start-row-container">
            <app-all-icons class="icon-size-2" [iconNameAndStyling]="'usd-icon.svg'"></app-all-icons>
            <span class="font-3 black-9">usd-icon.svg</span>
          </div>
          <div class="start-row-container">
            <app-all-icons class="icon-size-2" [iconNameAndStyling]="'user-icon.svg'"></app-all-icons>
            <span class="font-3 black-9">user-icon.svg</span>
          </div>

          <div class="start-row-container">
            <app-all-icons class="icon-size-2" [iconNameAndStyling]="'warning.svg'"></app-all-icons>
            <span class="font-3 black-9">warning.svg</span>
          </div>
          <div class="start-row-container">
            <app-all-icons class="icon-size-2" [iconNameAndStyling]="'whatsapp-logo.svg'"></app-all-icons>
            <span class="font-3 black-9">whatsapp-logo.svg</span>
          </div>
          <div class="start-row-container">
            <app-all-icons class="icon-size-2" [iconNameAndStyling]="'download-arrow-in-circle.svg'"></app-all-icons>
            <span class="font-3 black-9">download-arrow-in-circle.svg</span>
          </div>
          <div class="start-row-container">
            <app-all-icons class="icon-size-2" [iconNameAndStyling]="'upload-arrow-in-circle.svg'"></app-all-icons>
            <span class="font-3 black-9">upload-arrow-in-circle.svg</span>
          </div>
          <div class="start-row-container">
            <app-all-icons class="icon-size-2" [iconNameAndStyling]="'nooked-arrow.svg'"></app-all-icons>
            <span class="font-3 black-9">nooked-arrow.svg</span>
          </div>

          <div class="start-row-container">
            <app-all-icons class="icon-size-2" [iconNameAndStyling]="'reminders.svg'"></app-all-icons>
            <span class="font-3 black-9">reminders icon</span>
          </div>

          <div class="start-row-container">
            <app-all-icons class="icon-size-2" [iconNameAndStyling]="'reminders-active.svg'"></app-all-icons>
            <span class="font-3 black-9">reminders icon</span>
          </div>
          <div class="start-row-container">
            <app-all-icons [iconNameAndStyling]="'import.svg'"></app-all-icons>
            <span class="font-3 black-9">reminders icon</span>
          </div>

          <!-- //////////////////////////////////////////////////////////////// -->
        </div>
      </ng-container>
      <ng-container *ngSwitchCase="'Buttons'">
        <div class="space-between-horizontal-centered">
          <div class="container-row row-gap-1">
            <div class="space-between-horizontal-centered column-gap-0p75">
              <div class="centered-row-container row-gap-1">
                <app-button [type]="'default'" [showIcon]="'left'" [size]="'large'">Button</app-button>
                <app-button [type]="'default'" [showIcon]="'left'"></app-button>
                <app-button [type]="'default'" [showIcon]="'left'" [size]="'small'">Button</app-button>
                <app-button [type]="'default'" [showIcon]="'left'" [size]="'xsmall'">Button</app-button>

              </div>
            </div>
          </div>
          <div class="whitespace-1p25"></div>
          <div class="container-row row-gap-1">
          </div>
          <div class="whitespace-1p25"></div>
        </div>
        <div class="container-row">
          <div class="space-between-horizontal-centered">
            <app-cancel-button></app-cancel-button>
          </div>
          <div class="space-between-horizontal-centered">
            <app-copy-button></app-copy-button>
            <app-delete-button></app-delete-button>
            <app-edit-button></app-edit-button>
          </div>
          <div class="space-between-horizontal-centered">
            <app-excel-button></app-excel-button>
          </div>
          <div class="space-between-horizontal-centered">
            <app-three-dots-menu></app-three-dots-menu>
          </div>
        </div>
      </ng-container>

      <ng-container *ngSwitchCase="'Notifications'">
        <app-notifications></app-notifications>
      </ng-container>

      <ng-container *ngSwitchCase="'Modal'">
        <div class="centered-row-container">
          <button class="servc-button info-button" (click)="showThisCoolModal=true">
            Open modal
          </button>
          <app-button (buttonClick)="open.openModalNoTExt = true">
            Open no text modal
          </app-button>
          <app-button (click)="open.openModalWithText = true">
            Open with main text modal
          </app-button>
          <app-button (click)="open.openModalMInTExtAndAdditional =true">
            Open with main text modal
          </app-button>
          <app-button (click)="open.openModalNoInput">
            Open modal no input
          </app-button>

          <app-modal-dialog *ngIf="open.openModalNoTExt"
        (isConfirmed)="open.openModalNoTExt = false">

      </app-modal-dialog>
      <app-modal-dialog *ngIf="open.openModalWithText"
        [header]="'Mega header'"
        [mainText]="['Hello this is main text']"
        (isConfirmed)="open.openModalWithText = false">
      </app-modal-dialog>
      <app-modal-dialog *ngIf="open.openModalMInTExtAndAdditional"
        [header]="'Mega header'"
        [mainText]="['Hello this is main text with additional']"
        [addAdditionalText]="true"
        (isConfirmed)="open.openModalMInTExtAndAdditional = false">
      </app-modal-dialog>
      <app-modal-dialog *ngIf="open.openModalNoInput"
        [header]="'Mega header'"
        [showInput]="false"
       (isConfirmed)="open.openModalNoInput = false">
      </app-modal-dialog>
      </div>



        <app-modal-container *ngIf="showThisCoolModal" [title]="'Very gud title'" [buttons]="modalButtons"
                             (closeButtonClicked)="showThisCoolModal = false"
                             (dismissButtonClicked)="showThisCoolModal = false"
                             (applyButtonClicked)="sendSuccess(); showThisCoolModal=false">
          <div class="centered-column-container">

            <span>I like to write modals</span>
            <span>OH yeah, css, i like it, mhmm.... But how should I use it?</span>
            <span>Here is an example</span>
            <span>&nbsp;&lt;app-modal-container</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;[title]="'Very gud title'"</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;[hasDismissAndApplyButtons]="true"</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;*ngIf="showThisCoolModal"</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;(closeButtonClicked)="showThisCoolModal = false"</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;(dismissButtonClicked)="showThisCoolModal = false; resetValues()"</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;(applyButtonClicked)="updateObject()"></span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&lt;div class="centered-column-container"></span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&lt;span>I like to write modals&lt;/span></span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&lt;span>OH yeah, css, i like it mhmm....&lt;/span></span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&lt;/div></span>
            <span>&nbsp;&lt;/app-modal-container></span>

          </div>
        </app-modal-container>
      </ng-container>
      <ng-container *ngSwitchCase="'LinkedIn'">
        <app-input (inputChange)="catchName($event)"></app-input>
      </ng-container>
      <ng-container *ngSwitchCase="'drop-down'">
        <app-drop-down-item
          [text]="'plus'"
          [iconNameAndStyling]="'plus.svg'">
        </app-drop-down-item>

        <app-drop-down-item
          [text]="'edit-outline'"
          [iconNameAndStyling]="'edit-outline.svg'">
        </app-drop-down-item>

        <app-drop-down-item
          [text]="'anonymize'"
          [iconNameAndStyling]="'anonymize.svg'">
        </app-drop-down-item>
        <app-drop-down-item
          [text]="'duplicate'"
          [iconNameAndStyling]="'copy-outline.svg'">
        </app-drop-down-item>
        <app-drop-down-item
          [text]="'delete'"
          [iconNameAndStyling]="'delete.svg'">
        </app-drop-down-item>
        <app-drop-down-item
          [text]="'delete red'"
          [menuItemClass]="'red'"
          [iconNameAndStyling]="'delete.svg;red-10'">
        </app-drop-down-item>
        <app-drop-down-item
          [text]="'sell'"
          [iconNameAndStyling]="'usd-icon.svg'">
        </app-drop-down-item>
        <app-drop-down-item
          [text]="'update'"
          [iconNameAndStyling]="'update.svg'">
        </app-drop-down-item>
        <app-drop-down-item
          [text]="'exit'"
          [iconNameAndStyling]="'exit.svg'">
        </app-drop-down-item>
        <app-drop-down-item
          [text]="'excel'"
          [iconNameAndStyling]="'excel.svg'">
        </app-drop-down-item>

        <app-drop-down-item
          [text]="'unsell'"
          [iconNameAndStyling]="'unsell.svg'">
        </app-drop-down-item>
        <app-drop-down-item
          [text]="'arrow-down'"
          [iconNameAndStyling]="'white-arrow-down.svg'">
        </app-drop-down-item>
        <app-drop-down-item
        [text]="'arrow-down'"
        [iconNameAndStyling]="'white-arrow-down.svg'">
        </app-drop-down-item>
        <app-drop-down-item
        [text]="'report-settings'"
        [iconNameAndStyling]="'report-settings.svg'">
        </app-drop-down-item>
      </ng-container>

      <div *ngSwitchCase="'skeleton'">
        <app-standard-skeleton-table
          [tdAmount]="6"
          [trAmount]="6"
          [headers]="['Name','Fund','Group','Country', 'Cost', 'Fmv']">
        </app-standard-skeleton-table>
      </div>
      <div *ngSwitchCase="'tooltips'">
        <div class="flex gap-12">
          <div class="flex flex-col">
            <span>Left</span>
            <app-text-with-tooltip
              [text]="textForToolTip"
              [positionType]="'left'"/>
          </div>
          <div class="flex flex-col">
            <span>Centered</span>
            <app-text-with-tooltip
              [text]="textForToolTip"/>
          </div>
          <div class="flex flex-col">
            <span>Right</span>
            <app-text-with-tooltip
              [text]="textForToolTip"
              [positionType]="'right'"/>
          </div>
        </div>
      </div>
    </div>

  </div>
</section>
